import Controller, { OnClick } from '@philips-internal/oswald-ui-core/lib/client';
import { Inject } from '@odinjs/odin';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { Endpoint } from '../../constants/endpoints';
import BaseController from '../BaseController';
import { ApplicationRoute } from '../../constants/routes';

import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import { BaseToastProps, PanelAPI, ToastService } from '@philips-internal/oswald-ui-components';
import { PatientEvolutionAliases } from '../../codegen/constants/aliases/patient-evolution-aliases';
import { ToastLevel, ToastType } from '@philips-internal/oswald-ui-constants';

@Controller({ component: 'layout-patient-evolution', fragment: 'patient-evolution' })
class EvolutionPatientController extends BaseController {

  @Inject(PatientEvolutionAliases.PANEL_RELEASE)
  panelRelease!: PanelAPI;

  @Inject(PatientEvolutionAliases.SUBMIT_BUTTON)
  painelSubmit!: PanelAPI;

  patientEvolutionResponse = {};

  @OnClick(PatientEvolutionAliases.RELEASE_CANCEL_BUTTON)
  onClickCancel(): void {
    applicationContext.redirect(ApplicationRoute.ELECTRONIC_PATIENT_CHART +
      ApplicationRoute.PATIENT_LIST +
      ApplicationRoute.CLINICAL_NOTES_LIST);
  }

  @OnClick(PatientEvolutionAliases.RELEASE_SUBMIT_BUTTON)
  onClickRelease(): void {

    const toast: BaseToastProps = {
      dismissible: true,
      id: 'patient-evolution.error',
      level: ToastLevel.ERROR,
      message: 'tws.error-generic',
      showIcon: true,
      timeout: 5000,
      type: ToastType.BUBBLE,
    };

    const cdEvolucao = this.context.get('cdEvolucao');
    HttpService.put(
      Endpoint.PATIENT_EVOLUTION, { cdEvolucao }
    ).then(response => {
      if (response.status === 200 && response.body === true) {
        applicationContext.redirect(ApplicationRoute.ELECTRONIC_PATIENT_CHART +
          ApplicationRoute.PATIENT_LIST +
          ApplicationRoute.CLINICAL_NOTES_LIST);
      } else {
        ToastService.open(toast)
      }
    }).catch(() => ToastService.open(toast));

    this.painelSubmit.setVisible(false);
  }
}

export default EvolutionPatientController;
